module.exports = __webpack_public_path__ + "media/tags/mass-5-6e1f8b4a.png";